import React, { FC, ReactElement } from 'react';
import { WizardPage } from 'buyside/components/presentation/Form/Wizard/Wizard';
import { WizardContextProps } from 'interfaces/wizard/wizard';
import ProEmploymentStatus from './ProEmploymentStatus';
import { proEmploymentStatusSchema } from 'buyside/components/presentation/UserApplication/Helpers/validations';

const ProEmploymentStatusContainer: FC<{
  isLoading: boolean;
  isRobot: boolean;
  validationSchema: typeof proEmploymentStatusSchema;
}> = ({ validationSchema, isLoading, isRobot }): ReactElement => {
  return (
    <WizardPage validationSchema={validationSchema}>
      {({
        setFieldValue,
        touched,
        errors,
        values,
        setFieldError,
        initialValues
      }: WizardContextProps): ReactElement => (
        <ProEmploymentStatus
          setFieldValue={setFieldValue}
          touched={touched}
          errors={errors}
          values={values}
          isLoading={isLoading}
          setFieldError={setFieldError}
          isRobot={isRobot}
          initialValues={initialValues}
        />
      )}
    </WizardPage>
  );
};

export default ProEmploymentStatusContainer;
